"use client";

import { EmptyHeart, FilledHeart, Eye, NewCart } from "../../../public/Theme";
import { PRE_ORDER, settings } from "./constants";
import React, { useState } from "react";
import TypographyMontserrat, {
    Heading,
} from "../../Atoms/TypographyMontserrat";
import {
    addtoWishList,
    deleteItemfromWishList,
} from "../../../lib/bigcommerce/restfull/apis/wishlistAPIS";
import { calculateDiscountPercentage, formatPrice } from "../../utils/utils";

import Badge from "../../Atoms/Badge";
import { CATEGORY_IDS_FOR_PRE_ORDER } from "../../../public/Constants/EnumConstants";
import { FRONTEND_ENDPOINTS } from "../../../public/Constants/endpoints";
import Image from "next/image";
import Link from "next/link";
import LowStockIndicator from "../LowStockIndicator";
import ProductVideoPlayer from "../../Atoms/ProductVideoPlayer";
import PropTypes from "prop-types";
import QuickAddToCartButton from "../QuickAddToCartButton";
import Slider from "../../Atoms/Slider";
import { sendGTMEvent } from "@next/third-parties/google";
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";
import TypographyPoppins from "@/components/Atoms/TypographyPoppins";
import useStore from "@/lib/Store/useStore";

const ShoppingProductCard = ({
    images,
    link,
    name,
    categories,
    brandName,
    price,
    currencyCode,
    onClick,
    backInStockBadge,
    totalStockOfVariants,
    variants,
    sizeStandard,
    productId,
    isWishListItem,
    itemId,
    callServerAction,
    customerId,
    videoUrl,
    salesPrice,
    cardIndex,
    spanning = true,
}) => {
    const router = useRouter();
    const { layout } = useStore();

    const imagesCollection = images?.length > 3 ? images?.slice(0, 3) : images;

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    //For Pre-Order Slug on Product cards
    const isNewCollection = categories?.find((id) =>
        CATEGORY_IDS_FOR_PRE_ORDER?.includes(id)
    );

    const addProductToWishList = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!customerId) return router?.push("/login");

        try {
            await addtoWishList(parseInt(productId), customerId);
            callServerAction((prev) => !prev);
            toast("Item successfully added to wishlist", { type: "success" });
        } catch (error) {
            console.error({ error });
        }
    };
    const removeProductToWishList = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            await deleteItemfromWishList(customerId, itemId);
            callServerAction((prev) => !prev);
            toast("Item removed from wishlist", { type: "success" });
        } catch (error) {
            console.error({ error });
        }
    };

    const getColSpan = (index) => {
        // Repeat pattern every 6 cards:
        // 0, 1, 2, 3 → col-span-1 (4 cards)
        // 4, 5 → col-span-2 (2 cards)

        if (layout == "list") {
            return "col-span-12 md:col-span-6";
        }

        const pos = index % 6;
        return pos < 4
            ? "col-span-6 md:col-span-3"
            : "col-span-12 md:col-span-6";
    };

    return (
        <div
            onClick={onClick}
            key={name}
            className={`product-card ${spanning ? getColSpan(cardIndex) : ""} group cursor-pointer`}
        >
            <div className="w-full relative shop-card-dots">
                {/* Badges */}
                <div className="absolute top-5 left-2 md:left-5 z-10">
                    {isNewCollection ? (
                        <div className="w-max border p-1 bottom-0 bg-Pink_Rose bg-opacity-40  border-GRAY_61">
                            <TypographyPoppins
                                align="left"
                                customStyle="text-xs sm:text-sm"
                                fontWeight="bold"
                                text={PRE_ORDER}
                            />
                        </div>
                    ) : backInStockBadge ? (
                        <div className="w-max border p-1 bottom-0 bg-Pink_Rose bg-opacity-40 border-GRAY_61">
                            <TypographyPoppins
                                align="left"
                                customStyle="text-xs sm:text-xs"
                                fontWeight="normal"
                                text={"Back In Stock"}
                            />
                        </div>
                    ) : null}
                    {salesPrice && (
                        <div className="bg-expiry_red flex justify-center items-center mt-2 py-2 text-white w-[50px]">
                            <TypographyPoppins
                                size="8px"
                                align="left"
                                color={"text-white"}
                                fontWeight="normal"
                                text={calculateDiscountPercentage(
                                    formatPrice(price, currencyCode),
                                    salesPrice
                                )}
                            />
                        </div>
                    )}
                </div>

                {/* CTA (Eye,Cart) add bg-white */}
                <div className="absolute bottom-5 z-10 right-1  rounded-full h-[68px] w-[34px] flex flex-col justify-between items-center py-2">
                    {/* <QuickAddToCartButton
                        totalStockOfVariants={totalStockOfVariants}
                        showCarousel={true}
                        icon={Eye}
                        currencyCode={currencyCode}
                        sizeStandard={sizeStandard}
                        price={price}
                        productName={name}
                        productId={productId}
                        brandName={brandName}
                        imagesCollection={imagesCollection}
                        salesPrice={salesPrice}
                        isWishListItem={isWishListItem}
                        addProductToWishList={addProductToWishList}
                        removeProductToWishList={removeProductToWishList}
                    />
                    <QuickAddToCartButton
                        totalStockOfVariants={totalStockOfVariants}
                        showCarousel={false}
                        icon={NewCart}
                        currencyCode={currencyCode}
                        sizeStandard={sizeStandard}
                        price={price}
                        productName={name}
                        productId={productId}
                        brandName={brandName}
                        imagesCollection={imagesCollection}
                        salesPrice={salesPrice}
                        isWishListItem={isWishListItem}
                        addProductToWishList={addProductToWishList}
                        removeProductToWishList={removeProductToWishList}
                    /> */}
                </div>
                <Link
                    onClick={onClick}
                    href={`${FRONTEND_ENDPOINTS?.PRODUCTS}${link}`}
                    key={name}
                    prefetch
                    scroll
                    title={`View details for ${name}`}
                >
                    {imagesCollection?.length === 1 ? (
                        <div className="relative aspect-[5/8] w-full">
                            <Image
                                priority
                                quality={80}
                                src={
                                    imagesCollection?.[0]?.node?.url ||
                                    imagesCollection?.[0]?.url ||
                                    imagesCollection?.[0]?.url_zoom
                                }
                                alt={name}
                                fill
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                className="object-contain"
                            />
                        </div>
                    ) : (
                        <Slider
                            className="overflow-hidden"
                            {...settings}
                            afterChange={() => {
                                sendGTMEvent({
                                    event: "ImageInteractions",
                                    interaction_type: "Image Swiped",
                                    interaction_item: `Product Card: ${name}`,
                                });
                            }}
                        >
                            {imagesCollection?.map((image, index) => (
                                <div
                                    className="relative aspect-[5/8] w-full"
                                    key={index}
                                >
                                    <Image
                                        priority={index === 0}
                                        quality={75}
                                        src={
                                            image?.node?.url ||
                                            image?.url ||
                                            image?.url_zoom
                                        }
                                        alt={name}
                                        fill
                                        sizes="(max-width:768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        className="object-contain"
                                        loading={index === 0 ? "eager" : "lazy"}
                                    />
                                </div>
                            ))}
                        </Slider>
                    )}

                    {/* Allways keep the video element mounted */}
                    {/* <div
            className={`hidden lg:block w-full justify-center z-[9] absolute top-0 left-0  min-h-[300px] lg:min-h-[550px] max-h-[300px] lg:max-h-[550px] object-contain transition-opacity duration-300 ${
              isHovered ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {isHovered && videoUrl && (
              <ProductVideoPlayer
                url={videoUrl}
                isPlaying={isHovered}
                poster={imagesCollection && imagesCollection?.[0]?.url}
              />
            )}
          </div> */}
                </Link>
            </div>

            <Link
                onClick={onClick}
                href={`${FRONTEND_ENDPOINTS?.PRODUCTS}${link}`}
                key={name}
                prefetch
                scroll
                title={`View details for ${name}`}
            >
                <div className="mt-2 sm:mt-3 flex flex-col justify-between">
                    <div className="flex flex-col gap-y-1 sm:gap-y-1 w-full relative">
                        <div className="flex justify-between items-center">
                            <TypographyPoppins
                                decoration={"underline"}
                                // fontWeight={"medium"}
                                customStyle={
                                    "!text-[12px] sm:!text-[12px] !font-[500]"
                                }
                                text={brandName}
                                color={"New_Primary_Default"}
                            />
                            {/* <div>
                                {!isWishListItem ? (
                                    <Image
                                        onClick={addProductToWishList}
                                        src={EmptyHeart}
                                        width={24}
                                        height={24}
                                        alt="filled-heart"
                                    />
                                ) : (
                                    <Image
                                        onClick={removeProductToWishList}
                                        src={FilledHeart}
                                        width={24}
                                        height={24}
                                        alt="filled-heart"
                                    />
                                )}
                            </div> */}
                        </div>
                        <div className="flex justify-between items-center">
                            <TypographyPoppins
                                align="left"
                                customStyle="!text-[12px] sm:!text-[12px] font-[300] capitalize"
                                text={name}
                            />
                        </div>
                        {/* Pricing and Sale Pricing */}
                        <div className="flex items-center">
                            {salesPrice && (
                                <TypographyPoppins
                                    align="left"
                                    customStyle="!text-[14px] !font-medium sm:!text-[14px] mr-3 !text-expiry_red"
                                    text={salesPrice}
                                />
                            )}
                            {price && (
                                <TypographyPoppins
                                    align="left"
                                    customStyle={`!text-[14px] !font-[300] sm:!text-[14px] ${
                                        salesPrice && "line-through"
                                    }`}
                                    fontWeight="normal"
                                    text={formatPrice(price, currencyCode)}
                                />
                            )}
                        </div>
                        <LowStockIndicator
                            remainingStock={totalStockOfVariants}
                        />
                    </div>
                    {/* For Back in Stock Slug on Product cards*/}
                </div>
            </Link>
        </div>
    );
};

ShoppingProductCard.propTypes = {
    images: PropTypes.array.isRequired,
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    currencyCode: PropTypes.string.isRequired,
};

export default ShoppingProductCard;
